export const formatPermissions = (permissions) => {
  let permissionsObj = {}
  permissions.forEach((permission) => {
    permissionsObj[permission] = true
  })
  return permissionsObj
}
